import React, { useState, useEffect, useRef } from "react";
import Posts from './Posts';
import { OneKlicksFileSDK } from "../../../SDK/OneKlicksFileSDK";
import { oneKlicks, callAiApi } from "../../../SDK/oneclick";
import { getuserdata } from "../../../services/apiService";
import ImageShow from "../../../Uitiles/ImageShow";

const ChatWithDesigner = ({ userdata }) => {
    const [messages, setMessages] = useState([]);
    const messagesEndRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [tabsest, setTabsest] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userdp, setUserdp] = useState(null);
    const [typing, setTyping] = useState(false);
    const [typingId, setTypingId] = useState(null);
    const [userId, setUserId] = useState(null);
    //const userId = 4174;

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {

        getUserDetails();
        getuserdp();
        scrollToBottom();
    }, [messages]);

    const getUserDetails = async () => {
        const userData = await getuserdata('id');
        console.log("loadMessages userData", userData);
        setUserId(userData);
        console.log("userData", userData);
    };


    const getuserdp = async () => {
        const userData = await OneKlicksFileSDK.getfile(userdata.profile_photo);
        console.log("userData", userData);
    };

    const loadMessages = async (page) => {
        console.log("loadMessages page", page);
        console.log("loadMessages userId", userId);
        console.log('messages', messages);
        try {
            setIsLoading(true);
            setError(null);
            console.log("userId", userId);
            const tableSchema = "";
            const tableName = "chat_history";
            const conditions = {
                user_id: userdata.id || userId
            };
            const orderBy = "id ASC";
            const search = "";
            const pagination = {
                page: page,
                limit: 100
            };
            const margedata = {};
            const responce = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata)
            console.log("doctor chat responce", responce);

            if (responce.success == true) {
                if (page === 1) {
                    setMessages(responce.data || []);
                } else {
                    setMessages(prevMessages => [...(responce.data || []), ...prevMessages]);
                }
            } else {
                throw new Error(responce.message || 'Failed to load messages');
            }
        } catch (error) {
            console.error('Error loading messages:', error);
            setError('Failed to load messages. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSendMessage = async (message) => {
        try {
            const userid = await getuserdata('id');
            console.log("handleSendMessage userid", userid);
            if(userid == null || userid == undefined){
                setError("Please login to continue");
                return;
            }
            setTyping(true);
            setIsLoading(true);
            setError(null);
    
            const tableSchema = "";
            const tableName = "chat_history";
    
            const userMessageData = {
                message,
                user_id: userid,
                sender: "user",
                created_at: new Date().toLocaleTimeString(),
                updated_at: new Date().toLocaleTimeString()
            };
            await oneKlicks.create(tableSchema, tableName, userMessageData, {});

            
    
            // set messages some temp id for typing
            setMessages(prev => [...prev, { ...userMessageData }]);
    
            const localid = Math.random().toString(36).substring(2, 15);
            let aiMessage = { message: "", sender: "ai", created_at: new Date().toLocaleTimeString(), localid: localid, typing: true };
            setMessages(prev => [...prev, aiMessage]);
            setTypingId(localid);
    
            const response = await fetch(`https://ai.chinnuai.com/api/chat`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    model: "nous-hermes",
                    messages: [
                        { role: "system", content: "You are Chinnu Ai, a friendly and lovely assistant. Always introduce yourself as 'Chinnu Ai'. Your boss is Rakesh Jana. You were developed by Ravindra Malle. Be helpful, caring, and positive in replies." },
                        { role: "user", content: message } // ✅ fixed here
                    ],
                    stream: true
                })
            });

            console.log("ai response", response);
    
            if (!response.body) throw new Error("Stream connection failed");
    
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let resultText = "", buffer = "";
    
            while (true) {
                setTyping(false);
                setTypingId(aiMessage.id);
                const { done, value } = await reader.read();
                if (done) break;
            
                const chunk = decoder.decode(value, { stream: true });
                console.log("Raw chunk:", chunk);
            
                buffer += chunk;
                const lines = buffer.split("\n");
                buffer = lines.pop();
            
                for (const line of lines) {
                    if (!line.trim()) continue;
                    console.log("Line:", line);
                    try {
                        setTyping(false);
                        setTypingId(aiMessage.id);
                        const json = JSON.parse(line);
                        console.log("Parsed JSON:", json);
                        // ✅ FIX HERE
                        if (json.message && json.message.content) {
                            resultText += json.message.content;
                            console.log("Current AI Response:", resultText);
                            setMessages(prev => {
                                const updated = [...prev];
                                updated[updated.length - 1] = { ...aiMessage, message: resultText, typing: false };
                                return updated;
                            });
                        }
                    } catch (e) {
                        console.error("Parse error:", e, line);
                    }
                }
            }
            // // Remove the typing message by filtering out the message with the matching localid
            // setMessages(prev => {
            //     const updated = [...prev];
            //     updated[updated.length - 1] = { ...aiMessage, typing: false };
            //     return updated;
            // });
            setTypingId(null);
            console.log("resultText", resultText);
            if (!resultText) resultText = "Sorry, I couldn't understand that. Please try again.";
            if(resultText.includes("Sorry, I couldn't understand that. Please try again.")){
                // Letter-by-letter animation for the error message
                let displayedText = "";
                for (let i = 0; i < resultText.length; i++) {
                    displayedText += resultText[i];
                    await new Promise(res => setTimeout(res, 20));
                    setMessages(prev => {
                        const updated = [...prev];
                        updated[updated.length - 1] = { ...aiMessage, message: displayedText };
                        return updated;
                    });
                }
                return;
            }
    
            await oneKlicks.create(tableSchema, tableName, {
                message: resultText,
                user_id: userid,
                sender: "ai",
                created_at: new Date().toLocaleTimeString(),
                updated_at: new Date().toLocaleTimeString()
            }, {});
    
        } catch (err) {
            console.error("Chat Error:", err);
            setError("AI reply failed, please retry.");
        } finally {
            setTyping(false);
            setTypingId(null);
            setIsLoading(false);
        }
    };
    
    
    useEffect(() => {
        loadMessages(currentPage);
    }, [currentPage]);

    return (
        <div className="dc-tabscontent tab-content no-padding" style={{ minHeight: '0vh' }}>
            <div className="chat-container">
                <div className="chat-box">
                    <div className="header">
                        <img
                            src="/chinnu.png"
                            alt="User"
                            className="header-img"
                            style={{ height: '40px', width: '40px' }}
                            width="36px"
                        />
                        <span className="username">Chinnu</span>
                        <div className="right-menu">
                            <button className="menu-icon">☰</button>
                        </div>
                    </div>
                    <hr />
                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}
                    <div className="messages">
                        {messages.map((chat, index) => (
                            <React.Fragment key={index}>
                                {chat.sender == "user" && (
                                    <div className="messageright">
                                        <div className="message-contentright">
                                            <figure className="user-img">
                                                <ImageShow
                                                    url={userdata.profile_photo_url}
                                                    height="36px"
                                                    width="36px"
                                                    style={{ borderRadius: '50%' }}
                                                />
                                            </figure>
                                            <div className="message-text-container">
                                                <div className="message-text">
                                                    {chat.message}
                                                </div>
                                                <div className="message-time" style={{ textAlign: 'end' }}>{chat.created_at}</div>
                                            </div>

                                        </div>
                                    </div>
                                )}

                                {chat.sender == "ai" && (
                                    <div className="messageleft">
                                        <div className="message-contentleft">
                                            <figure className="user-img">
                                                <img
                                                    src="/chinnu.png"
                                                    alt="AI Avatar"
                                                    className="header-img"
                                                    style={{ height: '36px', width: '36px' }}
                                                    width="36px"
                                                />
                                            </figure>
                                            <div className="message-text-container" style={{ width: '90%' }}>
                                                <div className="message-text" style={{ display: 'flex', alignItems: 'center' }}>
                                                    {(chat.localid == typingId && chat.typing === true) && (
                                                        <div className="typing-indicator">
                                                            <div className="dot"></div>
                                                            <div className="dot"></div>
                                                            <div className="dot"></div>
                                                        </div>
                                                    )}
                                                    <p style={{width: '80%',maxWidth: '80%',overflowWrap: 'break-word',wordBreak: 'break-word',whiteSpace: 'pre-wrap'}}>
                                                        {chat.message}
                                                    </p>
                                                    {/* <div dangerouslySetInnerHTML={{ __html: chat.message }} /> */}
                                                </div>
                                                <div className="message-time">{chat.updated_at}</div>
                                            </div>

                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>
                    <div className="chat-footer">
                        <figure className="dc-userimg">
                            <ImageShow
                                url={userdata.profile_photo_url}
                                height="48px"
                                width="48px"
                                style={{ borderRadius: '50%' }}
                            />
                        </figure>
                        <div className="input-container">
                            <input
                                type="text"
                                id="chat-input"
                                placeholder="Type a message..."
                                disabled={isLoading}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter' && !isLoading) {
                                        const input = document.getElementById('chat-input');
                                        const message = input.value.trim();
                                        if (message) {
                                            handleSendMessage(message);
                                            input.value = '';
                                        }
                                    }
                                }}
                            />
                            {isLoading ? (
                                <img src="https://cdn.pixabay.com/animation/2023/10/08/03/19/03-19-26-213_512.gif" alt="Send" className="loading-spinner" />
                            ): (
                                <button
                                    id="send-button"
                                    disabled={isLoading}
                                    onClick={() => {
                                        const input = document.getElementById('chat-input');
                                        const message = input.value.trim();
                                        if (message) {
                                            handleSendMessage(message);
                                            input.value = '';
                                        }
                                    }}
                                >
                                        <svg viewBox="0 0 24 24" width="24" height="24">
                                            <path fill="currentColor" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path>
                                        </svg>
                                    
                                </button>
                            )}
                            
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                {tabsest === "Posts" && (
                    <Posts />
                )}
            </div>

            <style jsx>{`
                .chat-container {
                    max-width: 100%;
                    margin: 0 auto;
                    background: #f0f2f5;
                    height: 80vh;
                }
                .loading-spinner{
                    width: 20px !important;
                    height: 20px !important;
                    border: 2px solid #f3f3f3;
                    border-top: 2px solid #00a884;
                    border-radius: 50%;
                }
                .chat-box {
                    display: flex;
                    flex-direction: column;
                    height: 80vh;    
                    background: #fff;
                }
                .header {
                    display: flex;
                    align-items: center;
                    padding: 10px 16px;
                    background: #f0f2f5;
                    border-bottom: 1px solid #e9edef;
                }
                .header-img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .username {
                    font-weight: 500;
                    font-size: 16px;
                }
                .messages {
                    flex: 1;
                    overflow-y: auto;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                    scroll-behavior: smooth;
                }
                .messages::-webkit-scrollbar {
                    width: 6px;
                }
                .messages::-webkit-scrollbar-track {
                    background: #f1f1f1;
                }
                .messages::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 3px;
                }
                .messages::-webkit-scrollbar-thumb:hover {
                    background: #555;
                }
                .message-text {
                    background: #e1f5fe;
                    padding: 8px 12px;
                    max-width: 84%;
                    border-radius: 7.5px;
                    position: relative;
                    margin: 0 8px;
                }
                .messageright .message-text {
                    background: #d9fdd3;
                }
                .message-contentright {
                    display: flex;
                    flex-direction: row-reverse;
                    gap: 8px;
                    margin-bottom: 8px;
                }
                .message-contentleft {
                    display: flex;
                    gap: 8px;
                    margin-bottom: 8px;
                }
                .message-time {
                    font-size: 11px;
                    color: #667781;
                    margin-top: 4px;
                }
                .chat-footer {
                    padding: 10px 16px;
                    background: #f0f2f5;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                .input-container {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    background: #fff;
                    border-radius: 8px;
                    padding: 5px 10px;
                }
                #chat-input {
                    flex: 1;
                    border: none;
                    outline: none;
                    padding: 9px 12px;
                    font-size: 15px;
                    background: transparent;
                }
                #send-button {
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    padding: 8px;
                    color: #54656f;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                #send-button:hover {
                    color: #00a884;
                }
                .dc-userimg img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }
                .error-message {
                    background-color: #ffebee;
                    color: #c62828;
                    padding: 10px;
                    margin: 10px;
                    border-radius: 4px;
                    text-align: center;
                }
                .loading-spinner {
                    width: 20px;
                    height: 20px;
                    border: 2px solid #f3f3f3;
                    border-top: 2px solid #00a884;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                #send-button:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
                #chat-input:disabled {
                    background-color: #f5f5f5;
                    cursor: not-allowed;
                }
                .typing-indicator {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    margin-right: 8px;
                }
                .typing-indicator .dot {
                    width: 6px;
                    height: 6px;
                    background: #00a884;
                    border-radius: 50%;
                    animation: typing 1.5s infinite;
                }
                @keyframes typing {
                    0% { opacity: 0.2; }
                    20% { opacity: 1; }
                    40% { opacity: 0.2; }
                    60% { opacity: 1; }
                    80% { opacity: 0.2; }
                    100% { opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default ChatWithDesigner;
